import { useUserQuery } from "@graphql/users/users.g";
import { RouteObject, UIMatch } from "react-router";

import { queryClient } from "@api/queries";

import { PortalPage } from "@layouts/PortalPage/PortalPage.layout";

import { routes } from "@pages/routes";

import { CreateUser } from "./CreateUser/CreateUser.page";
import { User } from "./User/User.page";
import { Users } from "./Users/Users.page";

export const userRoutes = [
  {
    path: routes.portal.users.index.$path(),
    Component: PortalPage,
    handle: {
      breadcrumb: {
        title: "Staff",
      },
    },
    children: [
      {
        index: true,
        Component: Users,
        handle: { fullBleed: true },
      },
      {
        path: routes.portal.users.create.$path(),
        Component: CreateUser,
        handle: {
          breadcrumb: {
            title: "Create",
          },
        },
      },
      {
        path: routes.portal.users.user.$path(),
        Component: User,
        handle: {
          breadcrumb: async ({ params: { userId = "" } }: UIMatch) => {
            const data = await queryClient.fetchQuery({
              queryKey: useUserQuery.getKey({ userId }),
              queryFn: useUserQuery.fetcher({ userId }),
            });

            return {
              title: data.user?.name,
            };
          },
        },
      },
    ],
  },
] satisfies RouteObject[];
